export const getDomainWidth = (mobile: boolean, tablet: boolean) => {
  if (mobile) {
    return '220px';
  }
  if (tablet) {
    return '200px';
  }
  return '240px';
};
